export default __webpack_public_path__ + "static/media/companies-bloomberg.e37f4243.svg";